import axios from 'axios';
import { apiURL } from '../config';
import { getStorage, removeStorage, setCookie, setStorage } from '../utils';

const api = axios.create({
    baseURL: apiURL,
});

api.interceptors.request.use((config) => {
    // If the Authorization header is not set, we can set it here
    if (!config.headers['Authorization']) {
        const token = getStorage('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
    }
    return config;
});

/**
 * Sets the default Authorization header for all requests
 */
export const setDefaultAuthorizationHeader = (token: string) => {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setStorage('token', token); // Store the token in localStorage
};

export const cleanupUserData = () => {
    removeStorage('user');
    removeStorage('token');
    setCookie('worktype', 0, 0);
    setCookie('location', 0, 0);
};

export default api;
